import { SelectedStatus } from "@b2bportal/core-types";
import {
  type IContactInfo,
  ParentState,
  getCartInitialContext,
} from "@hopper-b2b/checkout";
import {
  type ISelectedTrip,
  type SessionInfo,
  SupportStatus,
  type TripDetails,
} from "@hopper-b2b/types";

import ClientLogo from "../../assets/client/client-logo.webp";
import { getPaymentInitialContext } from "../../checkout/states";
import type { FlightMachineContext } from "./types";

export const getInitialFlightMachineContext =
  function (): FlightMachineContext {
    return {
      ...getCartInitialContext(),
      ...getPaymentInitialContext(),
      sessionInfo: {} as SessionInfo,
      clientAssets: {
        logo: ClientLogo,
      },
      localStorageKey: "nubank-tracking-properties-air",
      flightSearch: {
        tripCategory: undefined,
        destination: null,
        origin: null,
        departureDate: null,
        returnDate: null,
        originCountryCode: "",
        destinationCountryCode: "",
        multicityRoutes: [],
      },
      flightShop: {
        tripDetails: {} as TripDetails,
        selectedTrip: {} as ISelectedTrip,
        shopPricingInfo: {
          fare: undefined,
        },
        departureLabel: "",
        returnLabel: undefined,
        airports: undefined,
        selectedMulticityTrips: [],
      },
      common: {
        tripPricing: undefined,
      },
      prediction: undefined,
      selectedAccount: undefined,
      featureFlags: {},
      [ParentState.passengerInformation]: {
        addPassport: false,
        currentInfantId: undefined,
        currentUserPassenger: undefined,
        error: undefined,
        infantOnlyError: false,
        isValidated: false,
        numPassengerAlertDismissed: false,
        selectedLapInfantIds: [],
        selectedPassengerIds: [],
        userPassengers: [],
        visited: false,
      },
      [ParentState.contactInformation]: {
        contactInfo: {} as IContactInfo,
        visited: false,
      },
      [ParentState.passport]: {
        error: undefined,
      },
      [ParentState.seatSelection]: {
        selectedSeats: [],
        selectedSeatSegments: [],
        cheapestSeat: undefined,
        seatMapHtml: undefined,
        seatMapRequest: undefined,
        seatsInfo: undefined,
        seatMapAvailable: undefined,
        visited: false,
        skipSeatSelection: false,
      },
      [ParentState.review]: {
        visited: false,
      },
      [ParentState.bookingConfirmation]: {},
      [ParentState.vipSupport]: {
        supportStatus: SupportStatus.vip,
      },
      [ParentState.priceDrop]: { candidateId: undefined },
      [ParentState.disruptionV1]: {
        providedOfferQuotes: [],
        selectedOfferQuote: undefined,
      },
      [ParentState.bagsSelection]: {
        extraBaggage: undefined,
        passengerBagsMap: new Map(),
        checkedBagsPrices: undefined,
      },
      [ParentState.cancelForAnyReasonV2]: {
        cfarQuoteId: undefined,
        cfarOffers: [],
        selectedOffer: { status: SelectedStatus.UNSELECTED },
        aggregatedShopTrackingProperties: undefined,
      },
    };
  };
